<template>
    <div>
        <div  class="w-full">
                <div class="row">
                    <div class="col-md-4 col-12 d-flex mb-2">
                        <input ref="filter" type="search" class="bg-grey-lighter text-grey-darkest w-5/6 focus:outline-none p-1 rounded-full ml-3 text-sm"
                               placeholder="Search by name..." @input="debounceFilter" v-model="filter">
                        <div class="flex-1 text-right pr-3">
                            <i v-if="data_loading" class="fa fa-spin fa-spinner text-grey-darkest" aria-hidden="true"></i>
                        </div>
                    </div>
                    <div class="col-md-8 col-12 d-flex justify-content-end">
                        <a v-if="canCreate" href="/company/create"
                           class="mr-1 border-2 border-followup-nav focus:outline-none font-semibold hover:bg-followup-nav hover:no-underline hover:text-white p-2 rounded-full text-sm text-followup-nav">New Company</a>
                        <button href="/company/create"
                                class="mr-1 focus:outline-none font-semibold bg-followup-nav text-white p-2 rounded-full text-sm"
                                @click="toggleAdvancedSearch">Advanced search</button>
                        <button
                            class="hidden xl:inline border-2 border-followup-nav focus:outline-none font-semibold hover:bg-followup-nav hover:no-underline hover:text-white p-2 rounded-full text-sm text-followup-nav"
                            @click="clearSearch">
                            Clear Search
                        </button>

                    </div>
                </div>
                <form @submit.prevent="goToPage(1)"  @reset="resetAdvancedForm" v-if="advanced_search" class="mt-3 mt-3">

                    <div class="col-md-12 flex flex-wrap border-solid border-2 border-gray-900">

                        <div class="w-full text-right m-2">
                            <button class="btn btn-primary mr-2" @click.prevent="openNewViewModel">{{ (editableCompanyView && editableCompanyView.id) ? 'Edit' : 'Save' }} Lists</button>
                            <input type="reset" class="btn btn-danger mr-2" value="Clear" />
                            <button class="btn btn-primary">Apply</button>
                        </div>

                        <div class="w-1/2">
                            <div class="form-group m-2">
                                <label for="name">Name</label>
                                <input type="text" class="form-control" v-model="advanced_form.name" placeholder="Company Name" id="name">
                            </div>
                        </div>

                        <div class="w-1/2">
                            <div class="form-group m-2">
                                <label for="address">Address</label>
                                <input type="text" class="form-control" v-model="advanced_form.address" placeholder="Company Address" id="address">
                            </div>
                        </div>

                         <div class="w-1/2">
                            <div class="form-group m-2">
                                <label for="city">City</label>
                                <input type="text" class="form-control" v-model="advanced_form.city" placeholder="Company City" id="city">
                            </div>
                        </div>

                         <div class="w-1/2">
                            <div class="form-group m-2">
                                <label for="state">State</label>
                                <input type="text" class="form-control" v-model="advanced_form.state" placeholder="Company State" id="state">
                            </div>
                        </div>

                         <div class="w-1/2">
                            <div class="form-group m-2">
                                <label for="zip">Zip Code</label>
                                <input type="text" class="form-control" v-model="advanced_form.zip_code" placeholder="Company Zip Code" id="zip">
                            </div>
                        </div>

                         <div class="w-1/2">
                            <div class="form-group m-2">
                                <label for="phone">Phone</label>
                                <input type="text" class="form-control" v-model="advanced_form.phone" placeholder="Company Phone" id="phone">
                            </div>
                        </div>

                         <div class="w-1/2">
                            <div class="form-group m-2">
                                <label for="fax">Fax</label>
                                <input type="text" class="form-control" v-model="advanced_form.fax" placeholder="Company Fax" id="fax">
                            </div>
                        </div>

                        <div class="w-1/2">
                            <div class="form-group m-2">
                                <label for="type">Company Type</label>
                                <multiselect
                                    :options="companyTypes"
                                    v-model="advanced_form.company_type"
                                    label="code"
                                />
                            </div>
                        </div>
                        <div class="w-1/2">
                            <div class="form-group m-2">
                                <label for="team_company_status">Company Status</label>
                                <multiselect
                                    :options="teamCompanyStatuses"
                                    v-model="advanced_form.team_company_status"
                                    label="name"
                                    value="id">
                                </multiselect>
                            </div>
                        </div>
                        <div class="w-50">
                            <div class="form-group m-2">
                                <label for="created_date">Created Date</label>
                                <datepicker v-model="advanced_form.created_date" format="MM/dd/yyyy"
                                            input-class="cursor-pointer rounded w-full p-1 text-sm focus:outline-none border-1 border-grey bg-white h-10">
                                </datepicker>
                            </div>
                        </div>

                        <div class="w-50">
                            <div class="form-group m-2">
                                <label for="last_update">Last Update</label>
                                <datepicker v-model="advanced_form.last_update" format="MM/dd/yyyy"
                                            input-class="cursor-pointer rounded w-full p-1 text-sm focus:outline-none border-1 border-grey bg-white h-10">
                                </datepicker>
                            </div>
                        </div>
                        <span v-for="(field, index) in company_custom_fields" class="w-50">
                        <div v-if="field.options.length == 0 && field.type !== 4">
                            <div class="form-group m-2">
                                <label>{{ field.label_value }}</label>
                                <input type="text" class="form-control" v-model="advanced_form.custom_fields[field.id]">
                            </div>
                        </div>
                        <div v-if="field.options.length > 0">
                            <div class="form-group m-2">
                                <label>{{ field.label_value }}</label>
                                <multiselect v-model="advanced_form.custom_fields[field.id]"
                                             :id="field.name + '-' + field.id"
                                             :placeholder="'Select ' + field.name"
                                             :options="field.options"
                                             :multiple="true"
                                             class="cursor-pointer w-full"
                                             track-by="id"
                                             label="name"
                                             value="id"
                                             :taggable="false"
                                             :close-on-select="false">
                                </multiselect>
                            </div>
                        </div>
                    </span>
                    </div>

                </form>
            </div>
        <div v-if="zero_search_results || companies.length > 0">

            <div v-if="zero_search_results">
                <div class="mt-32 text-center text-grey-darkest text-lg">No results found. Consider changing your search or creating a new company.</div>
            </div>
            <div v-if="companies.length > 0" class="bg-white shadow-md rounded mb-6 mt-4 overflow-auto">

                <div class="d-flex justify-content-between">
                    <div class="d-flex">
                        <draggable draggable=".item"
                                   handle=".handle"
                                   :list="companyViewList"
                                   @start="drag = true"
                                   @end="onUpdate">
                            <div class="item handle btn-group mb-1" v-for="view in companyViewList">
                                <button class="btn company-listing-dropdown-button btn-sm btn-outline-primary" :class="[(selectedCompanyViewListId == view.id ? 'selected-view-list' : '')]" type="button" @click="applyFilter(view)">
                                    {{ view.name }}
                                </button>
                                <button type="button" class="btn btn-sm btn-outline-primary company-listing-dropdown-button dropdown-toggle dropdown-toggle-split"
                                        data-toggle="dropdown" aria-haspopup="true" :id="view.id+'-'+view.name" aria-expanded="false">
                                </button>
                                <div class="dropdown-menu" :aria-labelledby="view.id+'-'+view.name">
                                    <a class="dropdown-item" @click="openRenameCompanyView(view)">Rename</a>
                                    <a class="dropdown-item" @click="editCompanyView(view)">Edit</a>
                                    <a class="dropdown-item" @click="deleteCompanyView(view.id)">Delete</a>
                                    <a class="dropdown-item" @click="updateDefaultStatus(view)">{{ view.is_default == 1 ? 'Remove as default view' : 'Set as default view' }}</a>
                                </div>
                            </div>
                        </draggable>

                        <button class="add-view-button"
                                @click="addNewCompanyView" type="button">
                            <b><i class="fa fa-plus mr-1" aria-hidden="true"></i>Add Lists</b>
                        </button>
                    </div>
                    <div>
                        <button class="btn btn-primary" @click="clearCompanyView" type="button" style="font-size: small">
                            <b>Clear View</b>
                        </button>
                    </div>
                </div>
                <div v-if="checked_company_ids.length > 0" class="w-full d-flex flex-wrap p-2 text-grey-darkest border-b border-grey-light">
                    {{checked_company_ids.length }} {{checked_company_ids.length == 1 ? 'company' : 'companies'}} selected
                </div>
                <div v-if="checked_company_ids.length > 0 && canCreate" class="w-full d-flex flex-wrap mt-1 mb-1 bg-grey-lightest text-xs text-grey-darkest border-b border-grey-light">
                    <b-form-checkbox
                        id="uncheckAll"
                        class="check_current_checkbox2"
                        v-model="uncheck_all"
                        name="uncheckAll"
                        @change="clearChecked"
                    ></b-form-checkbox>
                    <b-form-checkbox
                        id="checkAllCompany"
                        class="check_current_checkbox2 all_checkbox_edited"
                        v-model="check_all"
                        name="checkAllCompany"
                        @change="checkAll"
                    >Select All</b-form-checkbox>

                    <button type="button" class="bulk-update-button pl-3 py-1 px-3" @click="updateFieldUpdateModal">Update Field</button>
                    <update-company-field ref="updateFieldUpdateModal" :checked_company_ids="checked_company_ids" :masks="masks"
                        v-on:update-finished="massUpdateFinished"></update-company-field>
                    <button v-if="canDelete" type="button" class="bulk-update-button pl-3 py-1 px-3" @click="massCompanyDestroy">Delete</button>
                    <button :disabled="checked_company_ids.length > 1" :style="checked_company_ids.length > 1 ? {color: '#c7c7c7'} : ''" type="button" class="bulk-update-button pl-3 py-1 px-3" @click="showMergeCompanyForm = true">Merge</button>
                    <MergeCompany v-if="showMergeCompanyForm" @modalClosed="showMergeCompanyForm = false" :primaryCompanyObj="getObjectById(checked_company_ids[0])" ></MergeCompany>
                </div>

                <table class="text-left w-full border-collapse table-bordered" id="company-index">
                    <thead v-if="checked_company_ids.length == 0">
                    <tr>
                        <th class="py-1 bg-grey-lightest font-bold uppercase text-xs text-grey-darkest border-b border-grey-light text-center" style="width:3%">
                            <b-form-checkbox
                                id="checkFirstPageCompany"
                                class="check_current_checkbox_edited"
                                v-model="check_first_page"
                                name="checkFirstPageCompany"
                                @change="checkFirstPage"
                                :disabled="!canCreate"
                            ></b-form-checkbox>
                        </th>
                        <th v-for="column in columnsToShow" :class="(column.property_name != 'name' && column.property_name != 'contact_name')  ? 'hidden' : ''" class="py-1 px-1 bg-grey-lightest font-bold uppercase text-xs text-grey-darkest border-b border-grey-light whitespace-no-wrap md:table-cell column-header-resize">
                            <div class="column-resize">
                                <button v-if="availableSort[column.property_name]" class="font-bold uppercase text-xs text-grey-darkest hover:text-teal hover:no-underline focus:outline-none"
                                        :class="currentOrder.sortBy === column.property_name ? 'text-teal' : ''"
                                        @click="sortByColumn(column.property_name)">
                                    {{ column.name }}
                                    <i class="fa fa-xs ml-2" :class="{'fa-chevron-up' : currentOrder.direction === 'asc',
                                        'fa-chevron-down' : currentOrder.direction === 'desc'}"
                                    v-if="currentOrder.sortBy === column.property_name"></i>
                                </button>
                                <button v-else class="font-bold uppercase text-xs text-grey-darkest hover:text-teal hover:no-underline focus:outline-none">
                                    {{ column.name }}
                                </button>
                            </div>
                        </th>

<!--                        <th class="py-1 px-3 bg-grey-lightest font-medium uppercase text-xs text-grey-darkest border-b border-grey-light cursor-pointer" :class="{'text-primary font-weight-bold':sort.colunm === 'sequential_team_id'}" @click="sortBy('sequential_team_id')">-->
<!--                            Company Id-->
<!--                            <i  class="fa fa-xs ml-2"-->
<!--                                :class="{'fa-chevron-up' : sort.direction === 'asc',-->
<!--                                    'fa-chevron-down' : sort.direction === 'desc'}"-->
<!--                                v-if="sort.colunm === 'sequential_team_id'">-->
<!--                            </i>-->
<!--                        </th>-->

<!--                        <th class="py-1 px-3 bg-grey-lightest font-medium uppercase text-xs text-grey-darkest border-b border-grey-light cursor-pointer" :class="{'text-primary font-weight-bold':sort.colunm === 'name'}" @click="sortBy('name')">-->
<!--                            Company-->
<!--                            <i  class="fa fa-xs ml-2"-->
<!--                                :class="{'fa-chevron-up' : sort.direction === 'asc',-->
<!--                                    'fa-chevron-down' : sort.direction === 'desc'}"-->
<!--                                v-if="sort.colunm === 'name'">-->
<!--                            </i>-->
<!--                        </th>-->
<!--                        <th class="py-1 px-3 bg-grey-lightest font-medium uppercase text-xs text-grey-darkest border-b border-grey-light cursor-pointer" :class="{'text-primary font-weight-bold': sort.colunm === 'contact'}" @click="sortBy('contact')">-->
<!--                            Contact-->
<!--                            <i  class="fa fa-xs ml-2"-->
<!--                                :class="{'fa-chevron-up' : sort.direction === 'asc',-->
<!--                                    'fa-chevron-down' : sort.direction === 'desc'}"-->
<!--                                v-if="sort.colunm === 'contact'">-->
<!--                            </i>-->
<!--                        </th>-->
<!--                        <th class="py-1 px-3 bg-grey-lightest font-medium uppercase text-xs text-grey-darkest border-b border-grey-light cursor-pointer" :class="{'text-primary font-weight-bold': sort.colunm === 'email'}" @click="sortBy('email')">-->
<!--                            Email-->
<!--                            <i  class="fa fa-xs ml-2"-->
<!--                                :class="{'fa-chevron-up' : sort.direction === 'asc',-->
<!--                                    'fa-chevron-down' : sort.direction === 'desc'}"-->
<!--                                v-if="sort.colunm === 'email'">-->
<!--                            </i>-->
<!--                        </th>-->
<!--                        <th class="py-1 px-3 bg-grey-lightest font-medium uppercase text-xs text-grey-darkest border-b border-grey-light cursor-pointer" :class="{'text-primary font-weight-bold': sort.colunm === 'fax'}" @click="sortBy('fax')">-->
<!--                            Fax-->
<!--                            <i  class="fa fa-xs ml-2"-->
<!--                                :class="{'fa-chevron-up' : sort.direction === 'asc',-->
<!--                                    'fa-chevron-down' : sort.direction === 'desc'}"-->
<!--                                v-if="sort.colunm === 'fax'">-->
<!--                            </i>-->
<!--                        </th>-->
<!--                        <th class="py-1 px-3 bg-grey-lightest font-medium uppercase text-xs text-grey-darkest border-b border-grey-light cursor-pointer" :class="{'text-primary font-weight-bold': sort.colunm === 'address'}" @click="sortBy('address')">-->
<!--                            Address-->
<!--                            <i  class="fa fa-xs ml-2"-->
<!--                                :class="{'fa-chevron-up' : sort.direction === 'asc',-->
<!--                                    'fa-chevron-down' : sort.direction === 'desc'}"-->
<!--                                v-if="sort.colunm === 'address'">-->
<!--                            </i>-->
<!--                        </th>-->
<!--                        <th class="py-1 px-3 bg-grey-lightest font-medium uppercase text-xs text-grey-darkest border-b border-grey-light cursor-pointer" :class="{'text-primary font-weight-bold': sort.colunm === 'state'}" @click="sortBy('state')">-->
<!--                            State-->
<!--                            <i  class="fa fa-xs ml-2"-->
<!--                                :class="{'fa-chevron-up' : sort.direction === 'asc',-->
<!--                                    'fa-chevron-down' : sort.direction === 'desc'}"-->
<!--                                v-if="sort.colunm === 'state'">-->
<!--                            </i>-->
<!--                        </th>-->
<!--                        <th class="py-1 px-3 bg-grey-lightest font-medium uppercase text-xs text-grey-darkest border-b border-grey-light cursor-pointer" :class="{'text-primary font-weight-bold': sort.colunm === 'zip'}" @click="sortBy('zip')">-->
<!--                            ZIP-->
<!--                            <i  class="fa fa-xs ml-2"-->
<!--                                :class="{'fa-chevron-up' : sort.direction === 'asc',-->
<!--                                    'fa-chevron-down' : sort.direction === 'desc'}"-->
<!--                                v-if="sort.colunm === 'zip'">-->
<!--                            </i>-->
<!--                        </th>-->
<!--                         <th class="py-1 px-3 bg-grey-lightest font-medium uppercase text-xs text-grey-darkest border-b border-grey-light cursor-pointer" :class="{'text-primary font-weight-bold': sort.colunm === 'company_type'}" @click="sortBy('company_type')">-->
<!--                            Company Type-->
<!--                            <i  class="fa fa-xs ml-2"-->
<!--                                :class="{'fa-chevron-up' : sort.direction === 'asc',-->
<!--                                    'fa-chevron-down' : sort.direction === 'desc'}"-->
<!--                                v-if="sort.colunm === 'company_type'">-->
<!--                            </i>-->
<!--                        </th>-->
<!--                        <th class="py-1 px-3 bg-grey-lightest font-medium uppercase text-xs text-grey-darkest border-b border-grey-light cursor-pointer" :class="{'text-primary font-weight-bold': sort.colunm === 'pipeline'}" @click="sortBy('pipeline')">-->
<!--                            Pipeline-->
<!--                            <i  class="fa fa-xs ml-2"-->
<!--                                :class="{'fa-chevron-up' : sort.direction === 'asc',-->
<!--                                    'fa-chevron-down' : sort.direction === 'desc'}"-->
<!--                                v-if="sort.colunm === 'pipeline'">-->
<!--                            </i>-->
<!--                        </th>-->
<!--                        <th class="py-1 px-3 bg-grey-lightest font-medium uppercase text-xs text-grey-darkest border-b border-grey-light cursor-pointer" :class="{'text-primary font-weight-bold': sort.colunm === 'closing_ratio'}" @click="sortBy('closing_ratio')">-->
<!--                            Closing Ratio-->
<!--                            <i  class="fa fa-xs ml-2"-->
<!--                                :class="{'fa-chevron-up' : sort.direction === 'asc',-->
<!--                                    'fa-chevron-down' : sort.direction === 'desc'}"-->
<!--                                v-if="sort.colunm === 'closing_ratio'">-->
<!--                            </i>-->
<!--                        </th>-->
                        <th class="py-1 px-3 bg-grey-lightest font-medium uppercase text-xs text-grey-darkest border-b border-grey-light cursor-pointer">
                            <div class="d-flex justify-content-center">
                                <i class="fa fa-fw text-left fa-btn fa-external-link pointer export-btn mr-3"
                                   title="Export" v-on:click="exportToExcel"></i>
                                <company-export-icon
                                name="Companies"
                                :companies="companies"
                                :state="columns"
                                :filter="advanced_form"
                                v-on:stateUpdated="updateColumnState"
                                :isListExport="false"
                                :list="null"
                            />
                            </div>
                        </th>
                        <th class="bg-grey-lightest border-b border-grey-light"></th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr @click="showCompany(company)" class="hover:bg-grey-lighter cursor-pointer border-b-1 text-grey-darkest" v-for="(company, idx) in companies" :key="idx">
                        <td @click.stop="() => null"
                            class="px-3 py-2 py-lg-0 border-b border-grey-light text-xs cursor-default">
                            <input type="checkbox" class="bg-teal" v-model="checked_company_ids"
                                    :id="'companyCheckbox' + company.id" :name="'companyCheckbox' + company.id"
                                    :value="company.id" @click="checkCompany" :disabled="!canCreate">
                        </td>
                        <td v-for="column in columnsToShow" class="pl-2 border-b border-grey-light text-xs md:table-cell td-text-overflow"
                            :class="(column.property_name != 'name' && column.property_name != 'contact')  ? 'hidden' : ''"
                        >
                            <div v-show="column.property_name == 'name'" :class="(column.property_name != 'sequential_team_id') ? 'text-break' : ''">
                                {{ company.name }}
                            </div>
                            <div v-show="column.property_name == 'phone'" class="text-break">
                                <a v-if="company.phone" :href="`tel:${company.phone}`" class="text-teal hover:text-teal-dark">
                                    <formatted-phone v-if="company.phone" :phone="company.phone" :masks="masks"/>
                                </a>
                            </div>

                            <div v-show="column.property_name == 'address'" :class="(column.property_name != 'sequential_team_id') ? 'text-break' : ''">
                                {{ company.address }}
                            </div>

                            <div v-show="column.property_name == 'site'" :class="(column.property_name != 'sequential_team_id') ? 'text-break' : ''">
                                {{ company.site }}
                            </div>

                            <div v-show="column.property_name == 'contact'" :class="(column.property_name != 'sequential_team_id') ? 'text-break' : ''">
                                {{ company.contact ? company.contact.name : '' }}
                            </div>

                            <div @click.stop="() => null" v-if="((!column.is_custom_field && column.property_name == 'company_type') || (!column.is_custom_field && column.property_name == 'company_status') || (column.is_custom_field))" :class="(column.property_name != 'sequential_team_id') ? 'text-break' : ''">
                                <div :key="'key-'+company.id" :id="'id-'+company.id">
                                    <inline-update :column="column" :company="company" :companyTypes="companyTypes" :teamCompanyStatuses="teamCompanyStatuses" v-on:inlineUpdateLoadingEmit="updateInlineUpdateLoader"></inline-update>
                                </div>
                            </div>

                            <div v-show="column.property_name == 'fax'" :class="(column.property_name != 'sequential_team_id') ? 'text-break' : ''">
                                <formatted-phone
                                    v-if="company['fax']" :phone="company['fax']" :masks="masks"/>
                            </div>
                            <a v-show="column.property_name == 'email'" :href="`mailto:${company.contact.email ? company.contact.email : ''}`"
                               class="text-teal hover:text-teal-dark" :class="(column.property_name != 'sequential_team_id') ? 'text-break' : ''">
                                {{ company.contact.email }}
                            </a>
                            <span v-show="column.property_name != 'name' && column.property_name != 'phone' && column.property_name != 'address' && column.property_name != 'email'
                                    && column.property_name != 'contact' && column.property_name != 'fax' && column.property_name != 'site' && column.property_name != 'company_type'
                                    && column.property_name != 'company_status' && !column.is_custom_field"
                                  :class="(column.property_name != 'sequential_team_id') ? 'text-break' : ''">
                                {{ company[column.property_name] }}
                            </span>
                            <div v-show="column.property_name == 'child_companies'" :class="(column.property_name != 'sequential_team_id') ? 'text-break' : ''">
                                <a v-show="company.childCompaniesCount > 0" href="javascript:void(0);"  @click="showChildCompany(company)"> Child Companies </a>
                            </div>
                        </td>
                        <td class="px-4 border-b border-grey-light text-right hidden xl:table-cell">
                            <span class="material-icons">chevron_right</span>
                        </td>
<!--                        <td class="text-xs pl-4 py-1">-->
<!--                            <div class="text-sm">{{ company.sequential_team_id }}</div>-->
<!--                        </td>-->
<!--                        <td class="text-xs pl-2 py-1">-->
<!--                            <div class="text-sm">{{ company.name }}</div>-->
<!--                            <a v-if="company.phone" :href="`tel:${company.phone}`" class="text-teal hover:text-teal-dark">-->
<!--                                <formatted-phone-->
<!--                                    v-if="company.phone"-->
<!--                                    :phone="company.phone"-->
<!--                                    :masks="masks"/>-->
<!--                            </a>-->
<!--                        </td>-->
<!--                        <td class="text-xs pl-2 py-1" style="word-break: break-all">-->
<!--                            <div v-if="company.contact">-->
<!--                                {{contractName(company)}}-->
<!--                            </div>-->
<!--                        </td>-->
<!--                        <td class="text-xs pl-2 py-1">-->
<!--                            <div><a :href="`mailto:${company.contact.email}`" class="text-teal hover:text-teal-dark">{{ company.contact.email }}</a></div>-->
<!--                        </td>-->
<!--                         <td class="text-xs pl-2">-->
<!--                            <div>-->
<!--                                <formatted-phone-->
<!--                                    v-if="company.fax"-->
<!--                                    :phone="company.fax"-->
<!--                                    :masks="masks"/>-->
<!--                            </div>-->
<!--                        </td>-->
<!--                        <td class="text-xs pl-2" style="word-break: break-all">-->
<!--                            <div>{{ company.address }}</div>-->
<!--                            <div>{{ company.city }}</div>-->
<!--                        </td>-->
<!--                        <td class="text-xs pl-2">-->
<!--                            <div>{{ company.state }}</div>-->
<!--                        </td>-->
<!--                        <td class="text-xs pl-2">-->
<!--                            <div>{{ company.zip }}</div>-->
<!--                        </td>-->
<!--                        <td class="text-xs pl-2">-->
<!--                            <div>{{ `${company.company_type ? company.company_type.code : ''}` }}</div>-->
<!--                        </td>-->
<!--                        <td class="text-xs pl-2 py-1">-->
<!--                            <div>{{ company.pipeline_value }}</div>-->
<!--                        </td>-->
<!--                        <td class="text-xs pl-2 py-1">-->
<!--                            <div>{{ company.closing_ratio }}</div>-->
<!--                        </td>-->
<!--                        <td class="text-right">-->
<!--                            <span class="material-icons">chevron_right</span>-->
<!--                        </td>-->
                    </tr>
                    </tbody>
                </table>
            </div>
            <div class="flex justify-center">
                <div class="d-flex align-items-center mr-2">
                    Total of {{ pagination.meta.total }} records
                </div>
                <b-pagination
                    @change="goToPage"
                    v-model="pagination.meta.current_page"
                    :total-rows="pagination.meta.total"
                    :per-page="pagination.meta.per_page"
                    first-text="First"
                    prev-text="Prev"
                    next-text="Next"
                    last-text="Last"
                    v-if="pagination.meta.total > pagination.meta.per_page"
                >
                    <template class="here" #ellipsis-text><b-form-input v-model="specificPage" placeholder="Goto" class="gotoSpecificPage" :type="'number'" @keydown.enter="gotoSpecificPageNumber()"></b-form-input></template>
                </b-pagination>
                <div class="d-flex align-item-center ml-2" v-if="pagination.meta.total > 0">
                    <b-form-select v-model="itemPerPage" :options="itemPerPageOptions" class="text-teal border-0 bg-transparent" @change="changeItemPerPage()"></b-form-select>
                </div>
            </div>
        </div>
        <div v-else-if="data_loading" class="text-5xl text-grey-darkest text-center mt-32">
            <i class="fa fa-spin fa-spinner" aria-hidden="true"></i>
        </div>
        <div v-else class="mt-32 text-center text-grey-darkest text-lg">No results found. Consider changing your search or creating a new company.</div>
<!--        <div v-else class="mt-10 text-center">-->
<!--            <div class="flex-col">-->
<!--                <div>-->
<!--                    <img width="400" src="images/empty.svg">-->
<!--                </div>-->
<!--                <div class="mt-4">-->
<!--                    <div class="text-lg text-grey-darkest mb-2 flex justify-center">-->
<!--                        <div class="text-xl w-1/4 tracking-wide">You haven't created a company yet!</div>-->
<!--                    </div>-->
<!--                    <button @click="addCompany" class="bg-followup-nav px-4 py-2 rounded-full text-white focus:outline-none hover:bg-followup-nav-darker text-xl">Click here to add your first company!</button>-->
<!--                </div>-->
<!--            </div>-->
<!--        </div>-->

        <!-- Modal -->
        <div id="NewView" class="modal fade" role="dialog">
            <div class="modal-dialog">
                <!-- Modal content-->
                <div class="modal-content">
                    <div class="modal-header">
                        <h4 class="modal-title text-lg">{{ (editableCompanyView && editableCompanyView.id) ? 'Edit' : 'New' }} Lists</h4>
                        <button type="button" dusk="modal-close-button"
                                class="material-icons focus:outline-none text-grey-darkest hover:text-grey-darkest"
                                data-dismiss="modal">close
                        </button>
                    </div>
                    <div class="modal-body">
                        <input v-model="companyViewName" type="text" class="rounded p-2 text-grey-darkest text-sm focus:outline-none border-1 w-full">
                        <div class="text-red text-xs">{{
                                companyViewNameError
                            }}
                        </div>

                    </div>
                    <div class="modal-footer">
                        <button type="button" @click.prevent="saveNewView" class="btn btn-outline-primary rounded-full">
                            {{ (editableCompanyView && editableCompanyView.id) ? 'Edit' : 'Save' }} Lists
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <!-- Modal -->
        <div id="RenameView" class="modal fade" role="dialog">
            <div class="modal-dialog">
                <!-- Modal content-->
                <div class="modal-content">
                    <div class="modal-header">
                        <h4 class="modal-title text-lg">Rename Lists</h4>
                        <button type="button" dusk="modal-close-button" class="material-icons focus:outline-none text-grey-darkest hover:text-grey-darkest"
                                data-dismiss="modal">close
                        </button>
                    </div>
                    <div class="modal-body">
                        <input v-model="companyViewRename" type="text" class="rounded p-2 text-grey-darkest text-sm focus:outline-none border-1 w-full">
                        <div class="text-red text-xs">{{
                                companyViewRenameError
                            }}
                        </div>

                    </div>
                    <div class="modal-footer">
                        <button type="button" @click.prevent="renameCompanyView" class="btn btn-outline-primary rounded-full">
                            Save Lists
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="inlineUpdateLoading"
             class="text-5xl text-grey-darkest text-center mt-32 inline-update-loading">
            <i class="fa fa-spin fa-spinner" aria-hidden="true"></i>
        </div>
    </div>
</template>

<script>
    import FormattedPhone from '../shared/formatted-phone.vue';
    import Multiselect from 'vue-multiselect';
    import Datepicker from 'vuejs-datepicker';
    import CompanyExportIcon from "../project/company-export-icon";
    import draggable from 'vuedraggable';
    import inlineUpdate from '../company/inline-update.vue';
    import MergeCompany from "./merge-company";
    import axios from "axios";
    import Swal from "sweetalert2";

    export default {
        name:'my-companies',
        // props:['masks', 'symbols', 'userRole'],
        props:{
            availableColumns: {
                type: Array,
            },
            masks: {},
            state: {
                type: Array,
            },
            symbols: {},
            userRole:{},
            availableSort: {},
            customFields: {
                type: Array,
            },
            canDelete: {},
            customFieldTypeConstants: {},
            userItemPerPage: {},
            companyUserViewList: {
                type: Array,
            },
            canCreate: {}
        },
        data() {
            let companyState = this.state
            const stateCustomFields = this.customFields.map(customField => ({
                name: customField.label_value,
                checked: true,
                property_name: customField.name,
                is_custom_field: true,
                custom_field_id: customField.id,
                custom_field_type: this.customFieldTypeConstants[customField.type],
            }));
            let newState = [
                {
                    name: 'Company ID',
                    checked: true,
                    property_name: 'sequential_team_id',
                },
                {
                    name: 'Company',
                    checked: true,
                    property_name: 'name',
                },
                {
                    name: 'Child Companies',
                    checked: true,
                    property_name: 'child_companies',
                },
                {
                    name: 'Phone',
                    checked: true,
                    property_name: 'phone',
                },
                {
                    name: 'Contact',
                    checked: true,
                    property_name: 'contact',
                },
                {
                    name: 'Email',
                    checked: true,
                    property_name: 'email',
                },
                {
                    name: 'Fax',
                    checked: true,
                    property_name: 'fax',
                },
                {
                    name: 'Address',
                    checked: true,
                    property_name: 'address',
                }, {
                    name: 'City',
                    checked: true,
                    property_name: 'city',
                },
                {
                    name: 'State',
                    checked: true,
                    property_name: 'state',
                },
                {
                    name: 'Zip',
                    checked: true,
                    property_name: 'zip',
                },
                {
                    name: 'Website',
                    checked: true,
                    property_name: 'site',
                },
                {
                    name: 'Pipeline',
                    checked: true,
                    property_name: 'pipeline_value',
                },
                {
                    name: 'Company Type',
                    checked: true,
                    property_name: 'company_type',
                },
                {
                    name: 'Company Status',
                    checked: true,
                    property_name: 'company_status',
                },
                {
                    name: 'Closing Ratio',
                    checked: true,
                    property_name: 'closing_ratio',
                },
                ...stateCustomFields,
            ];
            if (companyState) {
                // companyState = companyState.filter((state) => {
                //     return (state.property_name !== "age" && state.property_name !== "meeting_date")
                // })
                const stateHash = companyState.reduce(function (map, obj) {
                    map[obj.name] = obj;
                    return map;
                }, {});
                newState = Object.values(stateHash);
            }else{
                const baseStateHash = newState.reduce(function (map, obj) {
                    map[obj.name] = obj;
                    return map;
                }, {});
                newState = Object.values(baseStateHash);
            }
            return {
                companies: '',
                filter: '',
                sort :{
                    direction: 'asc',
                    colunm: 'name'
                },
                page: 1,
                pagination: {
                    data: [],
                    meta: {},
                    links: {},
                },
                data_loading: true,
                zero_search_results: false,
                companyTypes:[],
                advanced_search: false,
                advanced_form:{
                    name: '',
                    address: '',
                    city: '',
                    state: '',
                    zip_code:'',
                    phone: '',
                    fax:'',
                    company_type:null,
                    team_company_status:null,
                    created_date:'',
                    last_update:'',
                    custom_fields:{},
                    advanced: true,
                },
                current_search_pattern: '',
                columns: newState,
                columnsToShow: this.availableColumns,
                availableSortingColumns: this.availableSort,
                currentOrder: {
                    sortBy: 'name',
                    direction: 'asc'
                },
                companyViewName: '',
                companyViewNameError: '',
                companyViewList: this.companyUserViewList ? this.companyUserViewList : [],
                companyViewId: '',
                companyViewRename: '',
                companyViewRenameError: '',
                drag: false,
                allCompanyIds: [],
                checked_company_ids: [],
                teamCompanyStatuses:[],
                check_all: false,
                uncheck_all: true,
                check_first_page:false,
                selectedView:null,
                specificPage:'',
                inlineUpdateLoading: false,
                company_custom_fields: {},
                itemPerPage: (this.userItemPerPage)? this.userItemPerPage.company:15,
                itemPerPageOptions: [
                    { value: 15, text: '15 per page' },
                    { value: 25, text: '25 per page' },
                    { value: 50, text: '50 per page' },
                    { value: 100, text: '100 per page' },
                ],
                showMergeCompanyForm : false,
                selectedCompanyViewListId: null,
                editableCompanyView: null
            }
        },
        components:{CompanyExportIcon, Multiselect,Datepicker, draggable, inlineUpdate,MergeCompany},

        watch: {
            // check_all: function(val){
            //     if(val) {
            //         this.checkAll();
            //     }
            // }
        },

        created() {
            let defaultView = _.find(this.companyViewList, ['is_default', 1]);
            if(defaultView !== null && defaultView !== undefined) {
                this.setSavedViewData(defaultView.filter);
                this.selectedCompanyViewListId = defaultView.id;
                this.fetchData(true, defaultView.filter);
            }
            else {
                this.selectedCompanyViewListId = null;
                this.fetchData();
            }
            this.getCompanyTypes();
            this.getTeamCompanyStatuses();
            this.fetchCustomFields();
        },

        methods: {
            fetchCustomFields() {
                let self = this;
                axios.get(route('api.company-custom-field.index') + '?company=true').then(({data}) => {
                    self.company_custom_fields = data.data;

                    let  custom = {};
                    for (let field in self.company_custom_fields) {
                        custom[self.company_custom_fields[field].id] = ''
                    }
                });
            },
            goToPage(page) {
                this.page = page;
                this.fetchData();
                // if(this.selectedView){
                //     this.selectedView.filter.page = page;
                //     this.fetchData(true, this.selectedView.filter);
                // }else{
                //     this.fetchData();
                // }

            },
            getObjectById(id) {
                return this.companies.find(obj => obj.id === id) || null;
            },
            getTeamCompanyStatuses() {
                let self = this;
                axios.get(route('api.company-status.index')).then(({data}) => {
                    self.teamCompanyStatuses = data;
                    self.teamCompanyStatuses.unshift({id:null, name:""});
                });
            },
            fetchData(hasFilter = false, filter = null) {
                let params = {};
                if(hasFilter) {
                    params = {
                        page:this.page,
                        colunm:this.currentOrder.sortBy,
                        direction: this.currentOrder.direction,
                        advanced_filter: true,
                        perPage: this.itemPerPage,
                        ...filter
                    };
                } else {
                    if (localStorage.getItem('companies.advanced_filter') || this.advanced_search) {
                        params = {
                            page:this.page,
                            colunm:this.currentOrder.sortBy,
                            direction: this.currentOrder.direction,
                            advanced_filter: true,
                            perPage: this.itemPerPage,
                            ...this.advanced_form
                        };
                        params.company_type = params.company_type ? params.company_type.id : null;
                        params.team_company_status = params.team_company_status ? params.team_company_status.id : null;
                        params.advanced = true;
                    } else {
                        params = {
                            filter: this.filter,
                            colunm:this.currentOrder.sortBy,
                            direction: this.currentOrder.direction,
                            page: this.page,
                            perPage: this.itemPerPage
                        };
                    }
                }
                this.current_search_pattern = params

                if(this.advanced_search){
                    localStorage.setItem('companies.advanced_filter', JSON.stringify(params))
                }

                this.data_loading = true;
                axios.get(route('api.company.index'), {params}).then(({data}) => {
                    this.companies = data.data;
                    this.allCompanyIds = data.allCompanyIds;
                    this.pagination = data;
                    this.data_loading = false;
                    this.zero_search_results = (this.filter && this.companies.length === 0);
                }).finally(() => {
                    this.advanced_search = false;
                    this.gotoInput();
                });
            },

            debounceFilter: _.debounce(function (e) {
                this.filter = e.target.value;
                this.advanced_search = false;
                if (localStorage.getItem('companies.advanced_filter')) {
                    localStorage.removeItem('companies.advanced_filter');
                }
                this.goToPage(1)
            }, 700),

            showCompany(company) {
                window.location = route('company.show', {company:company.id});
            },

            addCompany() {
                window.location = route('company.create');
            },
            contractName(company){
                return `${company.contact.title ? company.contact.title : ''} ${company.contact.name ? company.contact.name : ''}`;
            },

            // sortBy(colunm){
            //     this.sort.direction = this.sort.colunm === colunm ? (this.sort.direction === 'asc' ? 'desc' : 'asc') : 'asc';
            //     this.sort.colunm = colunm;
            //     this.goToPage(1);
            // },

            getCompanyTypes() {
                let self = this;
                axios.get(route('api.settings.codes.company-type.index')).then(({data}) => {
                    self.companyTypes = data;
                    self.companyTypes.push({id:null,code:""})
                });
            },

            // advancedSearch(hasFilter = false, filter = null){
            //     let params = {};
            //     if(hasFilter) {
            //         params = filter;
            //     } else {
            //         params = {
            //             page:this.page,
            //             colunm:this.sort.colunm,
            //             direction: this.sort.direction,
            //             advanced_filter: true,
            //             ...this.advanced_form
            //         };
            //         params.company_type = params.company_type ? params.company_type.id : null;
            //         params.team_company_status = params.team_company_status ? params.team_company_status.id : null;
            //         params.advanced = true;
            //     }
            //     this.current_search_pattern = params
            //     this.data_loading = true;
            //     axios.get(route('api.company.index'), {params}).then(({data}) => {
            //         this.companies = data.data;
            //         this.pagination = data;
            //     }).finally(()=>{
            //         this.advanced_search = false;
            //         this.data_loading = false;
            //         this.gotoInput();
            //     });
            // },
            resetAdvancedForm(){
                localStorage.removeItem('companies.advanced_filter');
                this.advanced_form = {
                    name: '',
                    address: '',
                    city: '',
                    state: '',
                    zip_code:'',
                    phone: '',
                    fax:'',
                    company_type:null,
                    created_date:'',
                    last_update:'',
                    custom_fields:{},
                    advanced: true,
                };
                // this.selectedView = null;
                this.specificPage = '';
            },
            setSavedViewData(filter){
                this.advanced_form = {
                    name: filter.name,
                    address: filter.address,
                    city: filter.city,
                    state: filter.state,
                    zip_code: filter.zip_code,
                    phone: filter.phone,
                    fax: filter.fax,
                    company_type: filter.company_type ? this.companyTypes.find(x => x.id === filter.company_type) : null,
                    team_company_status: filter.team_company_status ? this.teamCompanyStatuses.find(x => x.id === filter.team_company_status) : null,
                    created_date: filter.created_date,
                    last_update: filter.last_update,
                    advanced: true,
                    custom_fields: filter.custom_fields ?? {}
                };

                localStorage.setItem('companies.advanced_filter', JSON.stringify(filter))
            },
            updateColumnState(updatedStates) {
                this.columnsToExport = updatedStates.filter((updatedState) => {
                    if(updatedState.checked){
                        return updatedState
                    }
                })
            },
            sortByColumn(sortBy) {
                if (sortBy === this.currentOrder.sortBy) {
                    this.currentOrder.direction = (this.currentOrder.direction === 'asc') ? 'desc' : 'asc'
                }else {
                    this.currentOrder.sortBy = sortBy
                    this.currentOrder.direction = 'desc';
                }
                localStorage.setItem('companies.sortBy', this.currentOrder.sortBy);
                localStorage.setItem('companies.direction', this.currentOrder.direction);
                this.goToPage(1);
            },

            openNewViewModel() {
                this.companyViewName = (this.editableCompanyView && this.editableCompanyView.id) ? this.editableCompanyView.name : '';
                $("#NewView").modal("show");
            },

            saveNewView() {
                if(this.companyViewName.replace(/\s/g, '') === '') {
                    this.companyViewNameError = 'Name field is required'
                    return
                }

                this.companyViewNameError = '';

                let params = {
                    page: this.page,
                    colunm: this.sort.colunm,
                    direction: this.sort.direction,
                    advanced_filter: true,
                    ...this.advanced_form
                };

                params.company_type = params.company_type ? params.company_type.id : null;
                params.team_company_status = params.team_company_status ? params.team_company_status.id : null;
                params.company_view_name = this.companyViewName;

                let routeUrl = (this.editableCompanyView && this.editableCompanyView.id) ? 'api.company.update-company-view' : 'api.company.create-company-view';
                if(this.editableCompanyView && this.editableCompanyView.id) {
                    params.editableCompanyViewId = this.editableCompanyView.id;
                }

                axios.post(route(routeUrl), params).then(response => {
                    this.advanced_search = false;
                    this.fetchCompaniesView();
                    this.resetAdvancedForm();
                    if(this.editableCompanyView && this.editableCompanyView.id && this.editableCompanyView.id == this.selectedCompanyViewListId) {
                        this.clearCompanyView();
                    }
                    this.editableCompanyView = null;
                    this.getToast().fire({
                        type: 'success',
                        title: response.data.message
                    });
                });

                $('#NewView').modal('hide');
                this.companyViewName = '';
            },

            fetchCompaniesView(type = null) {
                let self = this;
                axios.get(route('api.company.company-view-list'))
                    .then(({data}) => {
                        self.companyViewList = data.data;
                        if(type === 'update-default-status') {
                            let defaultView = _.find(self.companyViewList, ['is_default', 1]);
                            if(defaultView !== null && defaultView !== undefined) {
                                self.setSavedViewData(defaultView.filter);
                                this.selectedCompanyViewListId = defaultView.id;
                                self.fetchData(true, defaultView.filter);
                            }
                            else {
                                self.resetAdvancedForm();
                                this.selectedCompanyViewListId = null;
                                self.fetchData();
                            }
                        }
                        this.onUpdate();
                });
            },

            openRenameCompanyView(view) {
                $("#RenameView").modal("show");
                this.companyViewId =  view.id;
                this.companyViewRename =  view.name;
            },

            renameCompanyView() {
                if(this.companyViewRename.replace(/\s/g, '') === '') {
                    this.companyViewRenameError = 'Name field is required'
                    return
                }

                this.companyViewRenameError = ''
                let params = {
                    name  : this.companyViewRename,
                    id  : this.companyViewId
                };

                axios.post(route('api.company.rename-company-view'), params).then(response => {
                    this.companyViewRename = '';
                    this.companyViewId = '';
                    this.fetchCompaniesView();
                    this.getToast().fire({
                        type: 'success',
                        title: response.data.message
                    });
                })
                $('#RenameView').modal('hide');
            },

            deleteCompanyView(viewId) {
                let self = this;
                Swal.fire({
                    title: "Are you sure?",
                    text: "Once deleted, you will not be able to recover this company lists!",
                    icon: "warning",
                    buttons: true,
                    showCancelButton: true,
                    confirmButtonColor: 'red',
                    confirmButtonText: 'I\'m sure!',
                    closeOnConfirm: true,
                    closeOnCancel: true,
                }).then(result => {
                    if (result.value) {
                        axios.delete(route('api.company.destroy-company-view', {
                            companyViewId: viewId
                        })).then((response) => {
                            self.fetchCompaniesView();
                            this.getToast().fire({
                                type: 'success',
                                title: response.data.message
                            });
                         }
                        )
                    }
                });
            },

            applyFilter(view) {
                // if(this.selectedView){
                //     if(this.selectedView.id == view.id){
                //         this.selectedView = null;
                //         this.page = 1;
                //         this.fetchData();
                //     }else{
                //         this.selectedView = view;
                //         this.fetchData(true, view.filter);
                //         this.setSavedViewData(view.filter)
                //     }
                // }else{
                //     this.selectedView = view;
                //     this.fetchData(true, view.filter);
                //     this.setSavedViewData(view.filter)
                // }
                this.setSavedViewData(view.filter)
                this.selectedCompanyViewListId = view.id;
                this.fetchData(true, view.filter);
            },

            onUpdate() {
                let self = this;
                self.companyViewList.forEach((viewList, index) => {
                    viewList.load_order = index;
                });
                axios.put(route('api.company.view-list-order'), self.companyViewList);
            },
            checkAll(val) {
                if(val){
                    this.checked_company_ids = this.allCompanyIds;
                }else{
                    this.check_all = false;
                    this.check_first_page = false;
                    this.checked_company_ids = [];
                }
            },
            checkCompany(id) {
                this.check_first_page = false;
                this.check_all = false;
                if(!event.target.checked){
                    if(this.checked_company_ids.indexOf(id, 0) !== -1){
                        this.checked_company_ids.splice(this.checked_company_ids.indexOf(id, 0), 1);
                    }
                }

                if(parseInt(this.checked_company_ids.length) == parseInt(this.allCompanyIds.length)) {
                    this.check_all = true;
                }
            },
            clearChecked() {
                this.check_all = false;
                this.check_first_page = false;
                this.checked_company_ids = [];
            },
            massCompanyDestroy() {
                if(this.canDelete) {
                    let params = {
                        company_ids: this.checked_company_ids
                    };
                    let titleString = this.checked_company_ids.length == 1 ? this.checked_company_ids.length+' company is selected, are you sure you want to delete it?' : this.checked_company_ids.length+' companies are selected, are you sure you want to delete them?';
                    let textString = this.checked_company_ids.length == 1 ? 'Record' : 'Records';
                    Swal.fire({
                        title: titleString,
                        text: textString+" can't be undo once deleted",
                        type: 'warning',
                        showCancelButton: true,
                        confirmButtonColor: '#01B1AF',
                        confirmButtonText: 'Yes, delete it!'
                    }).then((result) => {
                        if (result.value) {
                            axios.post(route('api.mass-company-project-check'), {company_ids: this.checked_company_ids}).then(({data}) => {
                                if (data.exists){
                                    Swal.fire({
                                        title: 'Related Projects Exists!',
                                        text: 'There are projects connected to the selected companies. Are you sure you want to continue deleting and removing the selected companies from all related projects?',
                                        type: 'warning',
                                        showCancelButton: true,
                                        confirmButtonColor: '#01B1AF',
                                        confirmButtonText: 'Yes, continue',
                                        closeOnConfirm: false,
                                    }).then((resultOther) => {
                                        if (resultOther.value) {
                                            this.massDeteleAfterCheck(params);
                                        }
                                    });
                                }
                                else {
                                    this.massDeteleAfterCheck(params);
                                }
                            });
                        }
                    });
                }
            },
            massDeteleAfterCheck(params){
                axios({
                    method: "post",
                    url: "api/company/mass-update/delete-company",
                    data: params,
                })
                    .then(function (response) {
                        Swal.fire({
                            title: 'Deleted',
                            text: 'The selected companies will be deleted shortly!',
                            type: 'success'
                        }).then(() => {
                            window.location.reload();
                        });
                    })
                    .catch(function (response) {
                        //
                    });
            },
            updateFieldUpdateModal() {
                if (this.checked_company_ids.length) {
                    this.$refs.updateFieldUpdateModal.open();
                    return;
                }
                this.noCompaniesCheckedAlert();
            },
            noCompaniesCheckedAlert() {
                Swal.fire({
                    title: 'No companies selected!',
                    text: "First, select the companies you want to update.",
                    type: 'error',
                    showCancelButton: false,
                    confirmButtonColor: '#01B1AF',
                    confirmButtonText: 'OK!',
                    closeOnConfirm: true,
                });
            },
            massUpdateFinished(data) {
                this.clearChecked();
                Swal.fire({
                    title: 'Success!',
                    text: data.message,
                    type: 'success',
                    showCancelButton: false,
                    confirmButtonColor: '#01B1AF',
                    confirmButtonText : 'OK!',
                    closeOnConfirm    : true,
                }).then(result => {
                    window.location.reload();
                });
            },
            checkFirstPage(){
                this.$nextTick(() => {
                    if(this.check_first_page){
                        let firstPageCompaniesIds = [];
                        this.companies.forEach(item => {
                            firstPageCompaniesIds.push(item.id);
                        });
                        this.checked_company_ids = firstPageCompaniesIds;
                    }
                });
            },
            gotoSpecificPageNumber(){
                this.page = this.specificPage;
                // if(this.selectedView){
                //     this.selectedView.filter.page = this.page;
                //     this.fetchData(true, this.selectedView.filter);
                // }else{
                //     this.fetchData();
                // }
                this.fetchData();
                this.specificPage = '';
            },
            gotoInput(){
                let targetNode = document.body;
                let config = { childList: true, subtree: true };

                let callback = function(mutationsList, observer) {
                    for(let mutation of mutationsList) {
                        if (mutation.type === 'childList') {
                            let item = document.querySelector(".gotoSpecificPage");
                            let parentItem = item.closest("li");
                            parentItem.classList.remove("disabled");
                        }
                    }
                };
                let observer = new MutationObserver(callback);
                observer.observe(targetNode, config);
            },
            updateInlineUpdateLoader(value) {
                this.inlineUpdateLoading = value;
            },
            exportToExcel() {
                axios.post(route('company.excel'), {
                    "filter": this.current_search_pattern,
                    "name": 'Companies',
                    "columns": this.columns.map(column => ({
                        name: column.name,
                        property_name: column.property_name
                    })),
                }).then(response => {
                    this.getToast().fire({
                        type: 'success',
                        title: 'Your report is being processed and will be available soon on your notifications.'
                    });
                }).catch(error => {
                    if (error.response.status === 403) {
                        this.getToast().fire({
                            type: 'warning',
                            title: 'You are not authorized to proceed with this action. Please contact your administrator.'
                        });
                        return false;
                    }else{
                        this.getToast().fire({
                            type: 'danger',
                            title: 'An error has occurred. Please contact your administrator.'
                        });
                    }
                });
            },
            clearSearch() {
                this.current_search_pattern = null;
                this.advanced_search = false;
                this.resetAdvancedForm();
                this.fetchData();
            },
            changeItemPerPage(){
                this.page = 1;
                this.$nextTick(() => {
                    this.fetchData();
                    this.updateItemPerPage();
                });
            },
            updateItemPerPage(){
                axios.post(route('user.update-item-per-page'), {item:'company', itemPerPage:this.itemPerPage});
            },
            showChildCompany(company){
                event.stopPropagation();
                window.location = route('company.show', {company: company.id, childCompany: 'childCompanies'});
            },
            updateDefaultStatus(view) {
                let self = this;
                axios.post(route('api.company.company-view.update-default-status'), {view}).then((response) => {
                    self.fetchCompaniesView('update-default-status');
                }).catch((error) => {
                    //
                });
            },
            clearCompanyView() {
                this.selectedCompanyViewListId = null;
                this.resetAdvancedForm();
                this.fetchData();
            },
            addNewCompanyView() {
                this.editableCompanyView = null;
                this.resetAdvancedForm();
                this.advanced_search = !this.advanced_search;
            },
            editCompanyView(view) {
                this.editableCompanyView = view;
                this.advanced_search = !this.advanced_search;
                this.setSavedViewData(view.filter);
            },
            toggleAdvancedSearch() {
                if(this.editableCompanyView) {
                    this.editableCompanyView = null;
                    this.resetAdvancedForm();
                }
                this.advanced_search = !this.advanced_search;
            }
        },
        mounted(){
            document.onreadystatechange = () => {
                if (document.readyState == "complete") {
                    let item = document.querySelector(".gotoSpecificPage");
                    let parentItem = item.closest("li");
                    parentItem.classList.remove("disabled");
                }
            }
        }
    }
</script>

<style>
    .pagination > li > a {
        color: #4dc0b5;
    }

    .pagination > li > a:hover {
        background-color: #4dc0b5 !important;
        color: white;
    }

    .cursor-pointer {
        cursor:pointer;
    }

    li.page-item.active > a {
        background-color: #4dc0b5 !important;
        border-color: #4dc0b5 !important;
    }

    a.page-link:focus {
        box-shadow: none;
    }

    .company-listing-dropdown-button{
        border-color: #14b1af !important;
        color: #14b1af !important;
    }

    .overflowStyle{
        overflow: auto;
    }

    .custom-height-class {
        height: 150px;
    }

    .company-listing-dropdown-button:hover,
    .company-listing-dropdown-button:active,
    .company-listing-dropdown-button:focus,
    .company-listing-dropdown-button:visited,
    .company-listing-dropdown-button:focus-visible,
    .company-listing-dropdown-button:focus-within,
    .company-listing-dropdown-button:target,
    .company-listing-dropdown-button .show > .btn-outline-success.dropdown-toggle {
        border-color: #14b1af !important;
        color: #ffffff !important;
        background-color: #14b1af !important;
        box-shadow:none !important;
    }

    .add-view-button {
        font-size: 13px;
        color: #14b1af;
        margin: 8px;
        outline: unset;
    }

    .check_current_checkbox_edited.custom-control.custom-checkbox {
        margin-left: 10px !important;
    }
    .all_checkbox_edited label {
        font-size: 14px;
        padding-top: 1px;
    }
    .gotoSpecificPage{
        height: 20px;
        padding: 0;
        margin: 0;
        width: 45px;
        text-align: center;
    }
    input[type=number]::-webkit-inner-spin-button,
    input[type=number]::-webkit-outer-spin-button {
        -webkit-appearance: none;
        margin: 0;
    }
    li.page-item.disabled.bv-d-xs-down-none {
        display: none;
    }
</style>

<style scoped>
    .selected-view-list{
        color: white !important;
        background-color: #14b1af !important;
    }
    .inline-update-loading {
        position: absolute;
        top: 50%;
        left: 50%;
    }
    #company-index .fix-name-content {
        white-space: nowrap;
        text-overflow: ellipsis;
        width: 10vw !important;
        display: block;
    }
    #company-index {
        border-collapse: collapse;
        border-spacing: 0px;
        overflow: scroll;
    }
    #company-index th.column-header-resize {
        padding: 0;
        margin: 0px;
    }
    #company-index th.column-header-resize div.column-resize {
        resize: horizontal;
        overflow: auto;
        min-width: 90%;
        margin: 0px;
        padding: 0px;
        display: block;
        border: 0;
    }
    #company-index td.td-text-overflow {
        overflow: hidden;
    }
    @media only screen
    and (min-device-width: 768px)
    and (max-device-width: 1024px)
    and (-webkit-min-device-pixel-ratio: 1) {
        td > span {
            white-space: nowrap;
            width: auto !important;
            display: block;
        }
        select {
            white-space: nowrap;
            width: auto !important;
            display: block;
        }
        #company-index .fix-name-content {
            white-space: nowrap;
            width: auto !important;
            display: block;
        }
    }
    @media only screen
    and (min-device-width: 768px)
    and (max-device-width: 1024px)
    and (orientation: portrait)
    and (-webkit-min-device-pixel-ratio: 1) {
        td > span {
            white-space: nowrap;
            width: auto !important;
            display: block;
        }
        select {
            white-space: nowrap;
            width: auto !important;
            display: block;
        }
        #company-index .fix-name-content {
            white-space: nowrap;
            width: auto !important;
            display: block;
        }
    }
</style>
